export const errorRefsPragmatic = {
  INSUFFICIENT_FUNDS: 'balanceTooLow',
  AUTHENTICATION_ERROR: 'Please login',
  NETWORK_ERROR: 'LostConnect',
  BET_WITHOUT_CONFIGURED_JACKPOT: '0',
  REQUEST_ERROR: '4',
  GENERIC_ERROR: '6',
  SESSION_EXPIRED: '8',
  LIMIT_REACHED: '101',
  BET_NOT_ALLOWED: '102',
};
